import React from 'react';
import {greyishBlue50} from "assets/jss/main";

import {TableCell} from "@mui/material";

function StyledTableCell(props) {
    return (
        <TableCell
            sx={{
                borderBottom: `1px solid ${greyishBlue50}`,
                padding: "16px",
                verticalAlign: "middle",
                ...props.sx
            }}
            {...props}
        >
            {props.children}
        </TableCell>
    );
}

export default StyledTableCell;
